import React from 'react';
import { BaseDataGridToolbar } from '../components';

interface EntityToolbarProps {
	searchValue?: string;
	onSearch?: (value: string) => void;
	onRefresh?: () => void;
	exportParams?: URLSearchParams;
	isMobile?: boolean;
}

interface CreateEntityToolbarConfig {
	searchPlaceholder: string;
	exportFn: (params: URLSearchParams) => Promise<void>;
}

/**
 * Factory that creates a typed toolbar component for a given entity.
 * Eliminates per-entity toolbar wrapper files by parameterizing only the
 * two things that differ: search placeholder text and export API call.
 */
export function createEntityToolbar({ searchPlaceholder, exportFn }: CreateEntityToolbarConfig) {
	const EntityToolbar: React.FC<EntityToolbarProps> = ({
		searchValue = '',
		onSearch,
		onRefresh,
		exportParams,
		isMobile = false,
	}) => (
		<BaseDataGridToolbar
			searchValue={searchValue}
			onSearch={onSearch}
			onRefresh={onRefresh}
			exportFunction={exportFn}
			searchPlaceholder={searchPlaceholder}
			exportParams={exportParams}
			isMobile={isMobile}
		/>
	);

	EntityToolbar.displayName = `EntityToolbar(${searchPlaceholder})`;
	return EntityToolbar;
}
